module.exports = __webpack_public_path__ + "img/20190806162001639.9d656ae7.png";